import { render } from "./BottomFixBlock.vue?vue&type=template&id=15bbaf6f&scoped=true"
import script from "./BottomFixBlock.vue?vue&type=script&lang=js"
export * from "./BottomFixBlock.vue?vue&type=script&lang=js"

import "./BottomFixBlock.vue?vue&type=style&index=0&id=15bbaf6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bbaf6f"]])

export default __exports__